import { PortalError } from './PortalError';

export class PrescriptionActivationError extends PortalError {
  constructor() {
    super('PrescriptionActivationError', 'Prescription was not activated', 'prescript_activated_error');
  }
}
